import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';

import TeamsAppForYouWatermelonQuery, {
	TeamsAppForYouWatermelonQuery as TeamsAppForYouWatermelonQueryType,
} from '../__generated__/TeamsAppForYouWatermelonQuery.graphql';

export const teamsAppForYouWatermelonResource: RouteResource<
	PreloadedQuery<TeamsAppForYouWatermelonQueryType, Record<string, unknown>>
> = createRelayResource<TeamsAppForYouWatermelonQueryType>({
	getQuery: (_routerContext, resourceStoreContext) => {
		const context = resourceStoreContext as unknown as HomeResourceContext;
		const workspaceId = context.workspace?.globalId ?? '';

		const isDisabled = !workspaceId;

		return {
			query: TeamsAppForYouWatermelonQuery,
			variables: {
				workspaceId,
				kudosQuery: '',
				kudosFirst: 5,
				skipQuery: isDisabled,
			},
			cacheKey: 'relay-teams-app-for-you-watermelon',
			options: { fetchPolicy: 'store-and-network' },
		};
	},
});
